import {
  Button,
  Card,
  CardBody,
  Collapse,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import PasswordInput from "../../../Forms/PasswordInput";
import { useState } from "react";
import { toast } from "react-toastify";
import { fetchController } from "../../../../utils/FetchController/fetchController";

export default function Security({ agency, baseUrl, logout }) {
  const { isOpen, onToggle } = useDisclosure();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const { buttonColorScheme } = agency;

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsValidate(true);
    if (!formData.password || formData.password !== formData.confirmPassword)
      return;

    try {
      setLoading(true);
      const response = await fetchController(
        `${baseUrl}/api/v1/login/reset_password`,
        "POST",
        {
          password: formData.password,
        }
      );
      if (response?.data) {
        logout();
      }
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.detail || "Some error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card maxW={"900px"} variant={"elevated"}>
      <CardBody display={"flex"} flexDirection="column" gap={3}>
        <Heading size="sm">Security & Access</Heading>
        <Text color="gray.600">
          Update your account password. Changes take effect immediately.
        </Text>

        <form onSubmit={(e) => { e.preventDefault(); onSubmit(e); }} style={{ width: "50%" }}>
          <Flex direction={"column"} gap={2}>
            <Collapse in={isOpen} animateOpacity>
              <FormControl isInvalid={isValidate && !formData.password}>
                <FormLabel>New Password</FormLabel>
                <PasswordInput
                  placeholder={"Enter new password"}
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                />
                {isValidate && !formData.password && (
                  <FormErrorMessage>
                    {"New password is required"}
                  </FormErrorMessage>
                )}
              </FormControl>

              <FormControl
                isInvalid={
                  isValidate && formData.password !== formData.confirmPassword
                }
              >
                <FormLabel>Confirm password</FormLabel>
                <PasswordInput
                  placeholder={"Enter confirm password"}
                  value={formData.confirmPassword}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      confirmPassword: e.target.value,
                    })
                  }
                />
                {isValidate &&
                  formData.password !== formData.confirmPassword && (
                    <FormErrorMessage>
                      {"Password should match"}
                    </FormErrorMessage>
                  )}
              </FormControl>
            </Collapse>
            
            <VStack align="start" spacing={3}>
              <Button
                type="button"
                colorScheme={isOpen ? buttonColorScheme : "gray"}
                isLoading={loading}
                size="sm"
                onClick={isOpen ? onSubmit : onToggle}
              >
                {isOpen ? "Change Password" : "Reset Password"}
              </Button>
            </VStack>
          </Flex>
        </form>

        <Divider />

        <Heading size="sm">API Keys</Heading>
        <VStack align="start" spacing={3}>
          <Button
            size="sm"
            variant={"solid"}
            colorScheme={buttonColorScheme}
            onClick={() => {
              window.open(
                "https://docs.insighto.ai/api-reference/calling/make-a-call",
                "_blank"
              );
            }}
          >
            Generate New API Key
          </Button>

          <Button
            size={"sm"}
            variant={"link"}
            colorScheme={buttonColorScheme}
            onClick={() => {
              window.open(
                "https://docs.insighto.ai/Insighto-Billing-Pay-As-You-Go",
                "_blank"
              );
            }}
          >
            View API Documentation
          </Button>
        </VStack>
      </CardBody>
    </Card>
  );
}
